export const errorMap = {
  'Unable to log in with provided credentials.': 'Rangt notandanafn eða lykilorð.',
  'This field may not be blank.': 'Þessi reitur má ekki vera tómur'
};

export const tryTranslateError = key => {
  return errorMap[key] || key;
};
